import { useState } from 'react';
import { carouselData } from '@/mocks/home';

export default function CarouselSection() {
  const [errors, setErrors] = useState<Record<number, boolean>>();

  const handleError = (index: number) => {
    setErrors((prev) => ({ ...prev, [index]: true }));
  };

  return (
    <section id="carousel" className="w-full px-4 md:px-6 lg:px-10 py-10 md:py-14">
      <div className="w-full">
        <div className="flex items-center justify-between mb-6">
          <div className="flex items-center gap-3">
            <div className="w-1.5 h-7 rounded-full bg-accent-500" />
            <h2 className="text-xl md:text-2xl font-bold text-foreground-950">精选专题</h2>
          </div>
          <span className="text-xs text-foreground-500 hidden sm:block">共6个专题 · 编辑团队定期精选</span>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {carouselData.map((item, index) => (
            <div
              key={index}
              className="group rounded-xl overflow-hidden border border-background-200/70 bg-background-50 hover:border-primary-200 transition-all duration-300 flex flex-col"
            >
              <div className="relative aspect-[3/2] bg-background-100 overflow-hidden">
                {!errors[index] ? (
                  <img
                    src={item.image}
                    alt={item.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    onError={() => handleError(index)}
                  />
                ) : (
                  <div className="w-full h-full flex items-center justify-center bg-background-100">
                    <div className="text-center">
                      <div className="w-12 h-12 mx-auto rounded-full bg-accent-100 flex items-center justify-center mb-2">
                        <i className="ri-image-line text-xl text-accent-600" />
                      </div>
                      <p className="text-xs text-foreground-400">{item.tag}</p>
                    </div>
                  </div>
                )}
                <div className="absolute top-3 left-3 flex items-center gap-2">
                  <span className="px-2.5 py-1 text-xs font-semibold bg-background-50/95 text-foreground-800 rounded-full backdrop-blur-sm">
                    {item.tag}
                  </span>
                </div>
                <div className="absolute bottom-3 right-3">
                  <span className="px-2.5 py-1 text-[11px] font-medium bg-black/50 text-background-50 rounded-full backdrop-blur-sm">
                    {item.meta}
                  </span>
                </div>
              </div>
              <div className="p-4 md:p-5 flex-1 flex flex-col">
                <h3 className="text-base font-semibold text-foreground-950 mb-2 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed flex-1">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}